import { render, staticRenderFns } from "./FingerPose.vue?vue&type=template&id=fff00cbc&"
import script from "./FingerPose.vue?vue&type=script&lang=js&"
export * from "./FingerPose.vue?vue&type=script&lang=js&"
import style0 from "./FingerPose.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports